import { State } from "@progress/kendo-data-query";
import { removeFilter } from "./RemoveFilter";

export function removeFieldsFromCurrentFilter(fieldsToRemove: string[], currentDataState: State) {
  const currentFilter = currentDataState.filter;

  if (!currentFilter) {
    return;
  }
  fieldsToRemove.forEach((field) => {
    removeFilter(currentFilter, field);
  });
}
